<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.control" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Дата: {{ $app.date.format(record.publishedAt) }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>

      <n-button v-if="edit.control && !checkIfSignIsExist(user.id, 'control')" @click="$var('acceptContr', true)">Подписать</n-button>
      <n-button v-if="edit.control && !checkIfSignIsExist(user.id, 'end.control')" @click="$var('acceptContrEnd', true)">Подписать</n-button>
      <n-button v-if="edit.welder && !checkIfSignIsExist(user.id, 'welder')" @click="$var('acceptWelder', true)">Подписать</n-button>
      <n-button v-if="edit.master && !checkIfSignIsExist(user.id, 'master')" @click="$var('acceptMast', true)">Подписать</n-button>
      <n-button v-if="edit.master && !checkIfSignIsExist(user.id, 'end.master')" @click="$var('acceptMastEnd', true)">Подписать</n-button>
    </div>
    <br />
    <n-items>
      <n-input title="№ п.п" v-bind="$form.input('number')" :text="!edit.control" />
      <n-input title="Номер сварного соединения по чертежам (исполнительным чертежам)" v-bind="$form.input('weldingNum')" :text="!edit.control" />
      <n-input title="Характеристика стыка, мм, Д х S, марка стали или композиция марок сталей, ГОСТ, ТУ, № сертификата" v-bind="$form.input('electrod')" :text="!edit.control" />
      <n-input title="Сварочные материалы (тип, марка, ГОСТ или ТУ, номер сертификата): Электроды" v-bind="$form.input('provolka')" :text="!edit.control" />
      <n-input title="Сварочные материалы (тип, марка, ГОСТ или ТУ, номер сертификата): Проволоки" v-bind="$form.input('flus')" :text="!edit.control" />
      <n-input title="Сварочные материалы (тип, марка, ГОСТ или ТУ, номер сертификата): флюс" v-bind="$form.input('guardingGas')" :text="!edit.control" />
      <n-input title="Сварочные материалы (тип, марка, ГОСТ или ТУ, номер сертификата): Защитный газ" v-bind="$form.input('journalNum')" :text="!edit.control" />
      <n-input title="Положение стыка (поворотное, неповоротное, вертикальное, горизонтальное)" v-bind="$form.input('weldPlace')" :text="!edit.control" />
      <n-datepicker inline title="Дата сварки" v-bind="$form.input('weldingDate')" :text="!edit.control" />
      <n-input title="Способ сварки (прихватки, корень шва, заполнение разделки)" v-bind="$form.input('weldingWay')" :text="!edit.control" />
      <n-input title="Температура воздуха в рабочей зоне, С" v-bind="$form.input('tempInside')" :text="!edit.control" />
      <n-input title="Температура предварительного, сопутствующего подогрева стыка, С" v-bind="$form.input('tempHeating')" :text="!edit.control" />
      <n-input title="Фамилия, Имя, Отчество сварщика, номер клейма" v-bind="$form.input('welder')" :text="!edit.control" />
      <n-input title="Дата термической обработки сварного соединения, номер журнала термической обработки и регистрационный номер в журнале" v-bind="$form.input('dateTermDoing')" :text="!edit.control" />
      <n-input title="Результаты внешнего осмотра и измерений, цветной или магнитной, порошковой дефектоскопии, номер протокола и дата" v-bind="$form.input('resultOut')" :text="!edit.control" />
      <n-input title="Способ контроля качества сварки (радиографическая, ультразвуковая дефектоскопия)" v-bind="$form.input('controlWay')" :text="!edit.control" />
      <n-input title="Дата проведения радиографического контроля или ультразвуковой дефектоскопии, номер заключения, номер журнала контроля" v-bind="$form.input('dateRadio')" :text="!edit.control" />
      <n-input title="Результаты замера содержания ферритной фазы в наплавленном металле, номер протокола и дата" v-bind="$form.input('resultFerrit')" :text="!edit.control" />
      <n-input title="Результаты замера содержания основных: легирующих элементов или стилоскопирования, номер протокола и дата" v-bind="$form.input('resultContain')" :text="!edit.control" />
      <n-input title="Отметки об устраненных дефектах" v-bind="$form.input('problemSolve')" :text="!edit.control" />
    </n-items>
    <br />
    <n-divide>
      <n-button v-if="edit.control" color="success" @click="save()">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>
    <c-modal-journal-do-sign v-if="$var('acceptContr')" @close="$var('acceptContr', false)" @submit="(s) => accept('control', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptContrEnd')" @close="$var('acceptContrEnd', false)" @submit="(s) => accept('end.control', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptWelder')" @close="$var('acceptWelder', false)" @submit="(s) => accept('welder', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptMast')" @close="$var('acceptMast', false)" @submit="(s) => accept('master', s)" />
    <c-modal-journal-do-sign v-if="$var('acceptMastEnd')" @close="$var('acceptMastEnd', false)" @submit="(s) => accept('end.master', s)" />
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        welder: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_welder', this.project.id),
        master: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_master', this.project.id),
        control: this.record.status === 'waiting' && $app.auth.can('journals_'+this.journal.name+'_control', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name, this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      this.$var('load', true)
      $api.journals.spec57.records.accept(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.spec57.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    checkIfSignIsExist(userId, signName) {
      let isExist = false
      if (this.record) {
        if (this.record.signs) {
          $n.each(this.record.signs, (el) => {
            if (el.authorId !== null || el.isApproved) {
              if (el.name === signName && el.authorId === userId && el.isApproved) {
                isExist = true
              }
            }
          })
        }
      }
      return isExist
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
